import { z } from "zod";

import { useForm, UseFormReturn } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { TopicFormData } from "../../topic/entities/Topic";
import {
  commentValidation,
  descriptionValidation,
  idValidation,
  idValidationOptional,
  imageValidation,
  listValidation,
  textValidation,
  textValidationOptional,
  titleValidation,
} from "../../../utils/validation";
import { TranslationFunction } from "../../../utils/utils";

export const useTopicFormValidation = (
  data: TopicFormData | null,
  t: TranslationFunction
): UseFormReturn<TopicFormData> => {
  const schema = z.object({
    title: titleValidation(t),
    description: descriptionValidation(t),
    trainingId: idValidation(),
    categoryId: idValidationOptional(),
    image: imageValidation(),
    level: z.string().optional(),
    status: z.enum(["draft", "available", "unavailable"], {
      errorMap: () => ({ message: t("validation.required") }),
    }),
    tags: listValidation(t),
    keywords: listValidation(t),
    introduction: textValidation(t),
    synthesis: textValidationOptional(),
    conclusion: textValidationOptional(),
    goals: listValidation(t),
    relatedTopicIds: z
      .array(z.string())
      .nullable()
      .optional()
      .transform((v) => v ?? []),
    comments: commentValidation(),
  });

  const form = useForm<TopicFormData>({
    resolver: zodResolver(schema),
    defaultValues: data || {},
  });

  useEffect(() => {
    form.reset({ ...(data ?? {}) });
  }, [data, form]);

  return form;
};
